module.exports = __webpack_public_path__ + "img/rwanda.477f4d81.svg";